export const intro = {
  title: `We partner with companies <br /> to build products that matter.`,
};

export const services_intro = {
  title: `Meet a few <br/> of our studio companies.`,
};

export const mobile_services_intro = {
  title: `Meet a few of our studio companies.`,
};

interface Service {
  description: string;
  frame: number;
  title: string;
}

export const mobile_services: readonly Service[] = [
  {
    title: 'Product + Engineering',
    description:
      'Companies bring us their big ideas and thorny problems. We transform them into ridiculously great products that people love.',
    frame: 37,
  },
  {
    title: 'Brand + Design',
    description:
      'Strong brands soar. Weak brands fizzle. Our team of designers, strategists, and copywriters will help you outshine and outperform.',
    frame: 57,
  },
  {
    title: 'Intellectual Property',
    description:
      'We know the difference between good patents and bad ones. We’ve secured dozens of good ones for our companies. Trademarks, too. ',
    frame: 78,
  },
  {
    title: 'Finance',
    description:
      'When it comes to money, we can help raise it, spend it thoughtfully, and figure out how to make more of it.',
    frame: 103,
  },
  {
    title: 'Recruiting',
    description: 'The better the team, the better the work. We’ll help you build your own team so you won’t need us.',
    frame: 126,
  },
] as const;

export const services: readonly Service[] = [
  {
    title: 'Product + Engineering',
    description:
      'Companies bring us their big ideas and thorny problems. We transform them into ridiculously great products that people love.',
    frame: 42,
  },
  {
    title: 'Brand + Design',
    description:
      'Strong brands soar. Weak brands fizzle. Our team of designers, strategists, and copywriters will help you outshine and outperform.',
    frame: 66,
  },
  {
    title: 'Intellectual Property',
    description:
      'We know the difference between good patents and bad ones. We’ve secured dozens of good ones for our companies. Trademarks, too. ',
    frame: 94,
  },
  {
    title: 'Finance',
    description:
      'When it comes to money, we can help raise it, spend it thoughtfully, and figure out how to make more of it.',
    frame: 120,
  },
  {
    title: 'Recruiting',
    description: 'The better the team, the better the work. We’ll help you build your own team so you won’t need us.',
    frame: 151,
  },
] as const;

export const spotlights = {
  airtime: {
    projectName: 'airtime',
    eyebrow: {
      title: 'airtime',
    },
    title: `Essential <br/>tools for <br/>video at work`,
    description: `<p>Airtime brings clearer communication and a dynamic presence to workplace video.</p>`,
    cta: "See Airtime's journey",
    url: '/airtime',
    animations: [],
    endImage: {
      src: '/images/sora/SoraBirds.png',
      alt: 'Sora Birds',
      width: 470,
      height: 337,
      classNames: 'absolute left-0 bottom-0',
    },
    frontImages: [],
    backAnimations: [],
    backImages: [],
  },
  bentoville: {
    projectName: 'bentoville',
    eyebrow: {
      title: 'bentoville',
    },
    title: `Fine dining <br/>takes the stage`,
    description: `<p>Bentoville celebrates the skill and showmanship of global cuisine.</p>`,
    cta: "See Bentoville's journey",
    url: '/bentoville',
    animations: [],
    endImage: {
      src: '/images/sora/SoraBirds.png',
      alt: 'Sora Birds',
      width: 470,
      height: 337,
      classNames: 'absolute left-0 bottom-0',
    },
    frontImages: [],
    backAnimations: [],
    backImages: [],
  },
  carrot: {
    projectName: 'Carrot',
    eyebrow: {
      title: 'carrot fertility',
    },
    title: `Fertility <br/>care for all`,
    description: `<p>Carrot provides access to personalized fertility care and family-building support, no matter what journey you’re on. </p>`,
    cta: 'Our partnership with Carrot',
    url: '/carrot',
    frontImages: [],
    backAnimations: [],
    backImages: [],
  },
  sora: {
    projectName: 'Sora Union',
    eyebrow: {
      title: 'sora union',
    },
    title: `Transforming <br/>adversity into <br/>opportunity`,
    description: `<p>Sora Union brings stable employment to knowledge workers worldwide displaced by conflict and climate change.</p>`,
    cta: 'How Sora came to life',
    url: '/sora',
    frontImages: [],
    backAnimations: [],
    backImages: [],
  },
};

export interface Partner {
  description: string;
  imageHeight: number;
  imageUrl: string;
  imageWidth: number;
  link: string;
  title: string;
}

export const partner_intro = {
  title: `In 8 years, we’ve invested in, started, or partnered with 45 companies, including:`,
};

export const partners: readonly Partner[] = [
  {
    title: 'Carrot Fertility',
    description: 'Supporting fertility and family-building for all',
    imageUrl: '/images/partners_carrot.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.get-carrot.com/',
  },
  {
    title: 'Airtime',
    description: 'Essential tools for video at work',
    imageUrl: '/images/partners_airtime.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.airtimetools.com',
  },
  {
    title: 'Sora Union',
    description: 'Creating opportunity for displaced knowledge workers',
    imageUrl: '/images/partners_sora.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://soraunion.com/',
  },
  {
    title: 'PwC',
    description: 'Improving health outcomes for your employees',
    imageUrl: '/images/partners_pwc.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.pwc.com/us/en.html',
  },
  {
    title: 'Bose',
    description: 'Diving into the future of audio applications',
    imageUrl: '/images/partners_bose.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.bose.com/home',
  },
  {
    title: 'Docomo',
    description: 'Designing neurodiverse productivity solutions',
    imageUrl: '/images/partners_docomo.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.docomo.ne.jp/english/',
  },
  {
    title: 'Rakuten',
    description: 'Exploring unconventional mobile experiences',
    imageUrl: '/images/partners_rakuten.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.rakuten.com/',
  },
  {
    title: 'Bentoville',
    description: 'Bringing world-class cuisine to America’s heartland',
    imageUrl: '/images/partners_bentoville.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.bentoville.com/',
  },
  {
    title: 'Cloaked',
    description: 'Restoring control over your online data and identity',
    imageUrl: '/images/partners_cloaked.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.cloaked.com/',
  },
  {
    title: 'Spot',
    description: 'Helping employees speak up when it matters',
    imageUrl: '/images/partners_spot.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://talktospot.com/index',
  },
  {
    title: 'Sunflower Labs',
    description: 'Pioneering autonomous safety and security',
    imageUrl: '/images/partners_sunflower.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://sunflower-labs.com/',
  },
  {
    title: 'Replika',
    description: 'Creating AI companions that form emotional connections',
    imageUrl: '/images/partners_replika.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://replika.com/',
  },
  {
    title: 'Miruni',
    description: 'Simplifying client feedback for makers',
    imageUrl: '/images/partners_miruni.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.miruni.io/',
  },
  {
    title: 'Sift',
    description: 'Curing news anxiety by unpacking complex issues',
    imageUrl: '/images/partners_sift.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://siftnewstherapy.com/',
  },
  {
    title: 'Surfboard',
    description: 'Improving board and investor communication for startups',
    imageUrl: '/images/partners_surfboard.svg',
    imageWidth: 101,
    imageHeight: 101,
    link: 'https://www.surfboard.team/',
  },
];
